import TRTCService from './WebTRTCService';
export default TRTCService;
